<template>
  <div id="app">
    <b-link variant="outline-light" v-b-toggle.sidebar-no-header
      ><img src="./assets/menu.png" height="32px" /><img
        src="./assets/logo.png"
        height="24px"
    /></b-link>
    <b-sidebar id="sidebar-no-header" aria-labelledby="sidebar-no-header-title">
      <template v-slot:default="{ hide }">
        <div class="p-3">
          <h4 id="sidebar-no-header-title">Menu</h4>
          <nav class="mb-3">
            <b-nav vertical>
              <b-nav-item to="/" @click="hide">Home</b-nav-item>
              <b-nav-item to="/solcalc" @click="hide"
                >ปรับความเข้มข้นแบบไม่เติม NaCl</b-nav-item
              >
              <b-nav-item to="/advcalc" @click="hide"
                >ปรับความเข้มข้นแบบเติม NaCl</b-nav-item
              >
              <b-nav-item to="/dm2rt" @click="hide"
                >คำนวณความเสี่ยงต่อการเป็น type 2 DM</b-nav-item
              >
            </b-nav>
          </nav>
        </div>
      </template>
    </b-sidebar>

    <router-view></router-view>
    <Kmpfooter></Kmpfooter>
  </div>
</template>

<script>
import Kmpfooter from "./components/Kmpfooter.vue";

export default {
  name: "app",
  components: {
    Kmpfooter,
  },
};
</script>

<style >
div {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  width: 400px;
  margin: auto;
  margin-top: 5px;
}
ul {
  margin: 0;
  margin-top: 15px;
  padding: 0;
}

li {
  margin-right: 8px;
  margin-left: 15px;
}
a:link,
a:visited,
a:hover,
a:active {
  text-decoration: none;
  color: #5b718a;
}
.title {
  font-size: 20px;
  margin-top: 20px;
  color: #364f6b;
  border-bottom: solid 1px;
}
div#warning {
  font-size: 16px;
  background-color: #ea97ad;
}
div#normal {
  font-size: 16px;
  background-color: #c6ebc9;
}
div#sop {
  margin-top: 10px;
  font-size: 16px;
  color: black;
}
h3#topic {
  margin-top: 0px;
  font-size: 18px;
  color: #364f6b;
  
}
h4#topic {
  margin-top: 5px;
  font-size: 16px;
  color: #364f6b;
  
}
label{
  margin-left: 2px;
  margin-right: 5px;
}
.desc {
  font-size: 12px;
  color: #e7669e;
}
.highlight {
  background-color: #ffd66b;
}
.topiclist {
  margin-left: -10px;
  list-style: none;
  }
img#arrow {
  height: 50px;
  }

</style>